import React from 'react';
import { useConnect } from '@lore/query-connect';
import REQUIRED_FIELDS from '../../projects/REQUIRED_FIELDS';
import { PayloadStates } from '@lore/utils';
import MetricLoader from '../MetricLoader';
import moment from 'moment-timezone';
import ComparisonMetric from '../ComparisonMetric';
import { creator_tags_educator } from '../../../utils/query-helpers';

export default function AssociatedWithProject(props) {
  const { network, schoolStart, schoolEnd, titleOnly } = props;

  const previousSchoolStart = moment(schoolStart).subtract(1, 'year').toISOString();

  const previousSchools = useConnect('site.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfProjects',
            relation: 'users.projects',
            $where: {
              $and: REQUIRED_FIELDS.$and,
              ...creator_tags_educator(),
              networkId: network?.id,
              createdAt: {
                $lte: schoolStart,
                $gte: titleOnly ? undefined : previousSchoolStart
              }
            }
          }
        ],
        $having: {
          numberOfProjects: {
            $gte: 1
          }
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  const newSchools = useConnect('site.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfProjects',
            relation: 'users.projects',
            $where: {
              $and: REQUIRED_FIELDS.$and,
              ...creator_tags_educator(),
              networkId: network?.id,
              createdAt: {
                $lte: schoolEnd,
                $gte: schoolStart
              }
            }
          }
        ],
        $having: {
          numberOfProjects: {
            $gte: 1
          }
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });

  if (
    previousSchools.state === PayloadStates.FETCHING ||
    newSchools.state === PayloadStates.FETCHING
  ) {
    return (
      <MetricLoader
        name="Associated with Project"
      />
    );
  }

  return (
    <ComparisonMetric
      name="Associated with Project"
      value={newSchools.meta.totalCount}
      previousValue={previousSchools.meta.totalCount}
      titleOnly={titleOnly}
    />
  );
}
